import GroupsIcon from '@mui/icons-material/Groups';
import PersonIcon from '@mui/icons-material/Person';
import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  DialogContentText,
  Grid,
} from '@mui/material';
import { useState, FC, useEffect } from 'react';
import { WsButton, IWorkAssignment, WsTypography } from 'wisestep-base';

interface IJobAssignmentSelection {
  open: boolean;
  assignment: IWorkAssignment;
  assignmentToTeams: string[];
  assignmentByRecruiters: string[];
  acceptJobAssignment(args: IWorkAssignment, args1: string | undefined): void;
  onClose(): void;
  closeJobSelectionDrawer?(): void;
}

const JobAssignmentSelection: FC<IJobAssignmentSelection> = ({
  open,
  assignment,
  assignmentToTeams,
  assignmentByRecruiters,
  acceptJobAssignment,
  onClose,
  closeJobSelectionDrawer,
}) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedId, setSelectedId] = useState<string | undefined>(undefined);
  const [selectedName, setSelectedName] = useState<string | undefined>(undefined);
  useEffect(() => {
    setOpenDialog(open);
  }, [open]);

  const handleClose = () => {
    setOpenDialog(false);
    if (closeJobSelectionDrawer && !selectedId) closeJobSelectionDrawer();
    else onClose();
  };

  const getSelectedId = (id: string | undefined, name: string | undefined) => {
    setSelectedId(id);
    setSelectedName(name);
  };

  const save = () => {
    handleClose();
    acceptJobAssignment(assignment, selectedId);
    onClose();
  };

  return (
    <Dialog open={openDialog} onClose={handleClose} maxWidth="md" sx={{ zIndex: '1500' }}>
      <DialogTitle>Select your Team/User</DialogTitle>
      <DialogContent sx={{ zIndex: '1500' }}>
        <DialogContentText>
          All your mappings and submissions will be tagged to this team/user.
        </DialogContentText>
        {assignmentToTeams.map((team: string, index: number) => (
          <Grid container key={index} mt={2}>
            <Grid item xs={2}>
              <GroupsIcon sx={{ fontSize: '40px' }} />
            </Grid>
            <Grid item xs={7}>
              <WsTypography>{assignment?.assignedToTeams[team]}</WsTypography>
            </Grid>
            <Grid item xs={3}>
              {selectedName !== assignment?.assignedToTeams[team] && (
                <WsButton
                  variant="outlined"
                  onClick={() => getSelectedId(team, assignment?.assignedToTeams[team])}
                >
                  Select
                </WsButton>
              )}
              {selectedName === assignment?.assignedToTeams[team] && (
                <WsButton onClick={() => getSelectedId(undefined, undefined)}>Deselect</WsButton>
              )}
            </Grid>
          </Grid>
        ))}
        {assignmentByRecruiters.map((recruiter: string, index: number) => (
          <Grid container key={index} mt={2}>
            <Grid item xs={2}>
              <PersonIcon sx={{ fontSize: '40px' }} />
            </Grid>
            <Grid item xs={7}>
              <WsTypography>{assignment?.assignedByRecruiters[recruiter]}</WsTypography>
            </Grid>
            <Grid item xs={3}>
              {selectedName !== assignment?.assignedByRecruiters[recruiter] && (
                <WsButton
                  variant="outlined"
                  onClick={() =>
                    getSelectedId(recruiter, assignment?.assignedByRecruiters[recruiter])
                  }
                >
                  Select
                </WsButton>
              )}
              {selectedName === assignment?.assignedByRecruiters[recruiter] && (
                <WsButton onClick={() => getSelectedId(undefined, undefined)}>Deselect</WsButton>
              )}
            </Grid>
          </Grid>
        ))}
      </DialogContent>
      <DialogActions>
        <WsButton onClick={handleClose}>Cancel</WsButton>
        <WsButton onClick={save}>Continue</WsButton>
      </DialogActions>
    </Dialog>
  );
};

export default JobAssignmentSelection;
